import angular from 'angular';
import Authentication from './authentication/authentication';
import Admin from './admin/admin';
import Reports from './reports/reports';
import V2 from './v2/v2';
import Logout from './logout/logout';

let componentModule = angular.module('app.components', [
  Authentication.name,
  Admin.name,
  Logout.name,
  Reports.name,
  V2.name
]);

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js